import type { SelectOptionCtx } from '@cli-types/next-adapter/generators.js'

export function buildSelectOptionFieldNames(ctx: SelectOptionCtx): string {
  return ctx.creatableSelectFields.map((field) => JSON.stringify(field.name)).join(', ')
}
